import enDictRaw from '../lang/en.json';

// helpers
function isIgnored(el) {
  if (!el) return true;
  if (el.closest && el.closest('[data-i18n="skip"]')) return true;
  const tag = (el.tagName || '').toUpperCase();
  return ['SCRIPT','STYLE','CODE','PRE','TEXTAREA','NOSCRIPT'].includes(tag);
}
function isVisible(el) {
  const s = getComputedStyle(el);
  return !(s.display === 'none' || s.visibility === 'hidden');
}
function normKey(s) {
  return String(s || '').replace(/\s+/g, ' ').trim();
}

function collectTextNodes(root) {
  const out = [];
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const txt = node.nodeValue || '';
      if (!txt.trim()) return NodeFilter.FILTER_REJECT;
      const parent = node.parentElement;
      if (!parent || isIgnored(parent) || !isVisible(parent)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  let n; while ((n = walker.nextNode())) out.push(n);
  return out;
}

function applyText(nodes, dict) {
  for (const n of nodes) {
    const full = n.nodeValue;
    const key = normKey(full);
    const tr = dict[key];
    if (!tr || tr === key) continue;

    const leading = full.match(/^\s*/)?.[0] ?? '';
    const trailing = full.match(/\s*$/)?.[0] ?? '';

    const parent = n.parentElement;
    if (parent && !parent.hasAttribute('data-orig')) {
      parent.setAttribute('data-orig', full);
    }
    n.nodeValue = leading + tr + trailing;
  }
}

function applyAttrs(root, dict) {
  const ATTRS = ['placeholder','title','aria-label'];
  const all = root.querySelectorAll('*');
  all.forEach(el => {
    if (isIgnored(el) || !isVisible(el)) return;
    for (const a of ATTRS) {
      const val = el.getAttribute(a);
      if (!val) continue;
      const key = normKey(val);
      const tr = dict[key];
      if (tr && tr !== key) {
        const backup = `data-orig-${a}`;
        if (!el.hasAttribute(backup)) el.setAttribute(backup, val);
        el.setAttribute(a, tr);
      }
    }
  });
}

function revertAll(root) {
  root
    .querySelectorAll('[data-orig-placeholder],[data-orig-title],[data-orig-aria-label]')
    .forEach(el => {
      ['placeholder','title','aria-label'].forEach(a => {
        const k = `data-orig-${a}`;
        if (el.hasAttribute(k)) {
          el.setAttribute(a, el.getAttribute(k));
          el.removeAttribute(k);
        }
      });
    });

  root.querySelectorAll('[data-orig]').forEach(el => {
    const orig = el.getAttribute('data-orig');
    if (orig != null) {
      el.textContent = orig;
      el.removeAttribute('data-orig');
    }
  });
}

const EN_DICT = (() => {
  const out = {};
  Object.keys(enDictRaw || {}).forEach(k => { out[normKey(k)] = enDictRaw[k]; });
  return out;
})();

// main
export class LangPacksDOM {
  constructor({ scopeSelector = '#root' } = {}) {
    this.scope = document.querySelector(scopeSelector) || document.body;
    this.lang = 'uk';
    this.dict = null;
    this.mo = null;
    this._applyAll = this._applyAll.bind(this);
  }

  async _loadDict(lang) {
    if (lang === 'uk') { this.dict = null; return; }
    if (lang === 'en') {
      this.dict = EN_DICT;
      return;
    }
    console.warn('[LangPacksDOM] Невідома мова:', lang, ' — вимикаю переклад.');
    this.dict = null;
  }

  _applyAll() {
    if (!this.dict) return;
    const nodes = collectTextNodes(this.scope);
    applyText(nodes, this.dict);
    applyAttrs(this.scope, this.dict);
  }

  async setLang(lang = 'uk') {
    if (this.mo) { try { this.mo.disconnect(); } catch {} this.mo = null; }

    if (lang === 'uk') {
      revertAll(this.scope);
      this.dict = null;
      this.lang = 'uk';
      return;
    }

    this.lang = lang;
    await this._loadDict(lang);
    this._applyAll();

    this.mo = new MutationObserver(() => this._applyAll());
    this.mo.observe(this.scope, { childList: true, subtree: true, characterData: true });
  }

  destroy() {
    if (this.mo) { try { this.mo.disconnect(); } catch {} this.mo = null; }
    revertAll(this.scope);
    this.lang = 'uk';
    this.dict = null;
  }
}
